import { Instance } from 'mobx-state-tree';
import { DriverFamiliarityScoreDtoModelBase } from './DriverFamiliarityScoreDtoModel.base';

/* The TypeScript type of an instance of DriverFamiliarityScoreDtoModel */
export interface DriverFamiliarityScoreDtoModelType extends Instance<typeof DriverFamiliarityScoreDtoModel.Type> {}

/* A graphql query fragment builders for DriverFamiliarityScoreDtoModel */
export { selectFromDriverFamiliarityScoreDto, driverFamiliarityScoreDtoModelPrimitives, DriverFamiliarityScoreDtoModelSelector } from './DriverFamiliarityScoreDtoModel.base';

/**
 * DriverFamiliarityScoreDtoModel
 */
export const DriverFamiliarityScoreDtoModel = DriverFamiliarityScoreDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
